import card from '../../components/card/locale/en.json';
import clipboard from '../../components/clipboard/locales/en.json';
import dataGrid from '../../components/datagrid/locale/en.json';
import statusChip from '../../components/status-chip/locale/en.json';
import dashboardLayout from '../../dashboard/dashboard-layout/locale/en.json';
import emptyStates from '../../feedback/empty-states/locales/en.json';
import errors from '../../feedback/errors/locales/en.json';

const enLocales = {
  card,
  clipboard,
  statusChip,
  errors,
  dataGrid,
  dashboardLayout,
  emptyStates,
};

export default enLocales;
